import {ReactNode} from 'react';
import {getTextLeaves} from './getTextLeaves';

/**
 * Flattens toast `content` into a single space-joined string suitable for a
 * screen-reader announcement. Custom components that don't pass `children`
 * through yield nothing, so those call sites must supply an explicit
 * `announce.message` instead.
 */
export const extractTextContent = (content: ReactNode): string =>
  getTextLeaves(content)
    .map(leaf => String(leaf).trim())
    .filter(Boolean)
    .join(' ');
